// extracted by mini-css-extract-plugin
export default {"title":"SmallFaintTextTheme_title__P7ugP","text":"SmallFaintTextTheme_text__koNOL","bold":"SmallFaintTextTheme_bold__kMMTO","link":"SmallFaintTextTheme_link__95Z35"};